import { render, staticRenderFns } from "./PSearchMenu.vue?vue&type=template&id=cfe15848"
import script from "./PSearchMenu.vue?vue&type=script&lang=js"
export * from "./PSearchMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports